@if (isShowAddToCartModal) {
  <section class="addtocartModal modal-wrap">
    <div class="box-dim" (click)="onCloseAddToCartModal()"></div>
    <div class="container">
      <header class="header">
        <h1>Select Option</h1>
        <h2>
          <a href="" [routerLink]="['/product', selectedProduct.id]">
            <!--<span>[{{ selectedProduct.brand.englishName }}]</span>-->
            {{ selectedProduct.englishName }}</a
          >
        </h2>
      </header>
      <div class="contents">
        <div class="box-spec">
          <!--single 일때 box-spec.single-->
          <table>
            <colgroup>
              <col width="35%" />
              <col width="65%" />
            </colgroup>
            <tbody>
              <tr>
                <th scope="row" [innerHTML]="'PRODUCT_DETAIL.MOQ_MIN' | t">MOQ (Minimum)</th>
                @if (selectedProduct.minMinMoq !== selectedProduct.maxMinMoq) {
                  <td>
                    {{ selectedProduct.minMinMoq | number }} ~ {{ selectedProduct.maxMinMoq | number }}
                    {{ 'TERM.UNITS' | t }}
                  </td>
                }
                @if (selectedProduct.minMinMoq === selectedProduct.maxMinMoq) {
                  <td>{{ selectedProduct.minMinMoq | number }} {{ 'TERM.UNITS' | t }}</td>
                }
              </tr>
              <tr>
                <th scope="row" [innerHTML]="'PRODUCT_OPTION.NON_SUPPLY_COUNTRY' | t">Non-Supply Country</th>
                <td>
                  <span>{{ selectedProduct.brand.invalidCountry | countryCode: ', ' }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="selected-option-list">
          <!-- <strong class="title">Select Option</strong> -->
          <div class="scroll">
            <div>
              <div>
                <ul>
                  @for (
                    saleProduct of selectedProduct.mapperSaleProducts | orderBy: 'productOption.englishOptionName';
                    track saleProduct
                  ) {
                    <li
                      [ngClass]="{
                        'out-of-stock': saleProduct?.productOption.productStatus === PRODUCT_STATUS.OUT_OF_STOCK,
                      }"
                    >
                      <mat-checkbox
                        class="checkbox"
                        [checked]="saleProduct.optionCheck"
                        (change)="addToSelect(saleProduct)"
                      ></mat-checkbox>
                      <span class="thumb" (click)="addToSelect(saleProduct)"
                        ><img src="{{ saleProduct ? (saleProduct?.productOption.images)[0].endpoint : '' }}"
                      /></span>
                      <strong (click)="addToSelect(saleProduct)">{{
                        saleProduct?.productOption.englishOptionName
                      }}</strong>
                      <em (click)="addToCart(saleProduct)">{{
                        saleProduct.productOption.productStatus !== PRODUCT_STATUS.OUT_OF_STOCK || null
                          ? '$' + (saleProduct.productOption.salePriceUSD | currency: 'USD' : '' : '0.2')
                          : ('BUTTON.OUT_OF_STOCK' | t)
                      }}</em>
                      <a (click)="addToCart(saleProduct)" class="button-cart"></a>
                    </li>
                  }
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <a class="close" [innerHTML]="'BUTTON.CLOSE' | t" (click)="onCloseAddToCartModal()"></a>
    </div>
  </section>
}
